import { i18n } from '@/plugins/i18n';

export default class ErrorMessageUtil {
  public static getErrorMessage(code: string): string {
    if (!code) {
      return '';
    }
    const key = `errors.${code}`;
    const message = i18n.global.t(key);
    return message === key ? '' : (message as string);
  }
}
